import { SALES_ITEM_RESTRICTION_TYPES } from 'src/models/inventory-strategy/InventoryStrategy'
import Model from 'src/models/model'
import { useGlobalProperties } from 'src/modules/register/composables/sales-restrictions/global-properties'
import { isOutOfStock } from 'src/services/inventory/sales-restrictions'
import availabilitiesAndConstraintsService from 'src/services/inventory/sales-restrictions/AvailabilitiesAndConstraintsService'
import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'

export function useCheckForSalesRestrictions () {
  const { $q } = useGlobalProperties()

  function checkForSalesRestrictions (model, options, successCallback) {
    // TODO OOS INDY-6757 This needs to use a reusable composable - ignores new availability restrictions
    // Composable will need to know to not execute isOutOfStock, but do execute out PRIVATE only checks?
    if (model.areSalesRequirementsUnmet || model.salesDisabled) {
      $q.dialog({
        title: 'Unavailable',
        message: 'Sales for this item are disabled.',
        ok: {
          label: 'Cancel',
          color: 'positive',
          outline: true
        }
      })

      return
    }

    const inventoryStrategy = getInventoryStrategy()

    if (
      availabilitiesAndConstraintsService.isModelInventoriable(model) &&
      _.includes(SALES_ITEM_RESTRICTION_TYPES.INTERVENTION, inventoryStrategy?.inventoryRestrictionType) &&
      isOutOfStock(model, options, true)
    ) {
      $q.dialog({
        title: 'Inventory Unavailable',
        message: 'This item is out of stock.',
        ok: {
          label: 'Cancel',
          color: 'positive',
          outline: true
        },
        ...(inventoryStrategy?.inventoryRestrictionType === SALES_ITEM_RESTRICTION_TYPES.RESTRICT
          ? {}
          : {
              cancel: {
                label: 'Continue',
                color: 'negative'
              }
            })
      }).onCancel(inventoryStrategy?.inventoryRestrictionType === SALES_ITEM_RESTRICTION_TYPES.RESTRICT
        ? undefined
        : () => {
            (
              inventoryStrategy?.inventoryRestrictionType === SALES_ITEM_RESTRICTION_TYPES.ADMIN_ONLY &&
              !Model.context.currentUser.admin
            )
              ? this.$emit('request-authorization', () => successCallback(true))
              : successCallback()
          })
    } else if (model.requiresAuthorization && !Model.context.currentUser.admin) {
      this.$emit('request-authorization', () => successCallback(true))
    } else {
      successCallback()
    }
  }

  return {
    checkForSalesRestrictions
  }
}
